import { Component, computed, inject, signal } from '@angular/core';
import { CommonModule } from '@angular/common';

import { FaIconLibrary, FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faBan, faWifi } from '@fortawesome/free-solid-svg-icons';

import { NetworkStatusService, TenantService } from '@core/services';
import { environment } from '@environments/environment';


@Component({
  selector: 'app-banner',
  standalone: true,
  imports: [CommonModule, FontAwesomeModule],
  templateUrl: './app-banner.component.html',
  styleUrl: './app-banner.component.scss'
})
export class AppBannerComponent {
  private readonly library = inject(FaIconLibrary);

  private readonly _tenantService = inject(TenantService);
  private readonly _networkStatusService = inject(NetworkStatusService);

  public environmentName = signal<string>(this.getEnvironmentName());
  public isOnline = this._networkStatusService.isOnline;
  public tenantName = this._tenantService.currentUriTenant;
  public shouldShow = computed(() => {
    const isProduction = environment.name === 'prod';
    return !isProduction;
  })

  public constructor() {
    const library = this.library;

    library.addIcons(faWifi, faBan);
  }

  private getEnvironmentName(): string {
    // Determine environment name based on API URL
    if (environment.name === 'dev') {
      return 'Development';
    } else if (environment.name === 'test') {
      return 'Testing';
    } else if (environment.name === 'prod') {
      return 'Production';
    }

    return 'Local';
  }

  public getBannerClass(): string {
    const env = environment.name;
    if (env === 'dev') {
      return 'banner-development';
    } else if (env === 'test') {
      return 'banner-testing';
    } else if (env === 'prod') {
      return 'banner-production';
    }
    return 'banner-local';
  }
}